<template>
  <b-container fluid>
    <b-row>
      <b-col
        cols="auto"
        class="my-auto"
      >
        <b-button
          size="sm"
          @click="tabSelectedHandler('createTestType')"
        >
          สร้างประเภทผลตรวจ
        </b-button>
      </b-col>
      <b-col class="my-auto">
        <b-button
          variant="success"
          size="sm"
          :class="{
            'change-sequence-btn': true,
            visible: !disabled
          }"
          @click="updateTestTypesSequenceHandler"
        >
          บันทึกลำดับ
        </b-button>
      </b-col>
      <b-col class="my-auto">
        <b-button
          variant="danger"
          size="sm"
          :class="{
            'change-sequence-btn': true,
            opacity: !disabled
          }"
          @click="resetTestTypeSequenceHandler"
        >
          รีเซ็ตลำดับ
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  export default {
    name: "TestTypeTitle",
    props: {
      disabled: {
        type: Boolean,
        default: false,
      },
      tabSelected: {
        type: String,
        default: null
      }
    },
    computed: {
      tabSelectedComputed: {
        get() {
          return this.tabSelected
        },
        set(value) {
          this.$emit('update:tabSelected', value)
        }
      }
    },
    methods: {
      async resetTestTypeSequenceHandler() {
        const confirm = await this.$swal.fire({
          title: 'ยืนยันการรีเซ็ตลำดับ',
          text: "คุณต้องการรีเซ็ตลำดับประเภทผลตรวจที่ได้เปลี่ยนแปลงไปใช่หรือไม่?",
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'รีเซ็ต',
          cancelButtonText: 'ยกเลิก',
        })

        if (confirm.value) {
          this.$emit('reset')
        }
      },
      async updateTestTypesSequenceHandler() {
        const { value: password } = await this.$swal.fire({
          title: 'กรอกรหัสผ่านเพื่อดำเนินการต่อไป',
          input: 'password',
          inputAttributes: {
            autocapitalize: 'off',
            autocorrect: 'off'
          }
        })

        if (password) {
          this.$emit('update', password)
        } else {
          return
        }

      },
      tabSelectedHandler(tab) {
        this.tabSelectedComputed = tab
      },
    }
  }
</script>

<style lang="scss" scoped>
  .change-sequence-btn {
    // transition: all 130ms ease-out;
    opacity: 0;
    &.visible {
      opacity: 1;
    }
  }
</style>